module.exports = __webpack_public_path__ + "media/fonts/alternate-gothic-no3-regular-webfont-e3cf81450dfe8c2d328adf4d241a069e.ttf";